import { UtilsService } from "../../services";

export interface ICustomerSiteLogModel {
	customerSiteLogId: number;
	customerId: number;
	showBeforePhotos: boolean;
	showAfterPhotos: boolean;
	showDamage: boolean;
	assets: ICustomerSiteLogAssetModel[];
}

export interface ICustomerSiteLogAssetModel {
	customerSiteLogAssetId: number;
	customerSiteLogId: number;
	name: string;
	sortOrder: number;
	documentKey: string;
}

export class CustomerSiteLogAssetModel implements ICustomerSiteLogAssetModel {
	constructor() {
		this.documentKey = UtilsService.newGuid();
	}
	customerSiteLogAssetId = 0;
	customerSiteLogId = 0;
	name = "";
	sortOrder = 0;
	documentKey: string;
}

export class CustomerSiteLogModel implements ICustomerSiteLogModel {
	customerSiteLogId = 0;
	customerId = 0;
	showBeforePhotos = false;
	showAfterPhotos = false;
	showDamage = false;
	assets: ICustomerSiteLogAssetModel[] = [];
}
